import { CMSApi } from 'api/index';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { currentLanguage } from 'shared/constants/common';
import pl from './translation/pl';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	pl: {
		translation: pl,
	},
};

export default i18n
	.use(initReactI18next as any) // passes i18n down to react-i18next
	.init({
		resources,
		lng: currentLanguage,
		keySeparator: false, // we do not use keys in form messages.welcome
		interpolation: {
			escapeValue: false,
		},
	});

export const fetchLocalisation = async () => {
	try {
		const response = await CMSApi.getTranslation(currentLanguage);
		const translation = response.data?.data[0]?.languageData;

		if (!response.data.isError && translation) {
			i18n.addResourceBundle(currentLanguage, 'translation', translation);
			i18n.changeLanguage(currentLanguage);
		}
	} catch (err) {
		console.error(err);
	}
};
